import { brlMaskedToDecimalApiString } from "./currency.util";
import {
  formatarDataExibicaoBr,
  formatarDataIsoLocal,
  intervaloDatasInvalido,
} from "./dataFiltro.util";
import { normalizarConciliacaoItem } from "./conciliacao.util";

/** Padrão ao abrir extrato: somente não ignorados. */
export const defaultFiltrosConciliacao = {
  filtroIgnorado: "nao",
  descricao: "",
  quantiaBusca: "",
  contaDebito: "",
  descricaoDebito: "",
  contaCredito: "",
  descricaoCredito: "",
  dtInicio: "",
  dtFim: "",
};

/** Estado após "Limpar filtros": sem filtro na coluna ignorar. */
export const filtrosConciliacaoLimpos = {
  filtroIgnorado: "todos",
  descricao: "",
  quantiaBusca: "",
  contaDebito: "",
  descricaoDebito: "",
  contaCredito: "",
  descricaoCredito: "",
  dtInicio: "",
  dtFim: "",
};

export function deveBloquearPorIntervaloInvalido(dtInicio, dtFim) {
  return intervaloDatasInvalido(dtInicio, dtFim);
}

/**
 * Body do PUT filtrar-intervalo.
 * Sem datas → intervalo vazio (remove recorte no backend).
 */
export function montarBodyIntervaloExportacao(dtInicio, dtFim) {
  const ini = formatarDataIsoLocal(dtInicio);
  const fim = formatarDataIsoLocal(dtFim);
  if (!ini && !fim) {
    return { intervalo: {} };
  }
  return {
    intervalo: {
      ...(ini ? { dtInicio: ini } : {}),
      ...(fim ? { dtFim: fim } : {}),
    },
  };
}

/**
 * Params enviados a buscarConciliacoes (antes do URLSearchParams do service).
 */
export function montarParamsBuscarConciliacoes(filtros, meta = {}) {
  const f = filtros ?? defaultFiltrosConciliacao;
  const quantiaApi = brlMaskedToDecimalApiString(f.quantiaBusca ?? "");
  return {
    tipoContabil: meta.tipoContabil ?? "dominio",
    pagina: meta.pagina ?? 0,
    tamanhoPagina: meta.tamanhoPagina ?? 10,
    filtroIgnorado: f.filtroIgnorado,
    descricao: f.descricao ?? "",
    quantiaBusca: quantiaApi ?? "",
    contaDebito: f.contaDebito ?? "",
    descricaoDebito: f.descricaoDebito ?? "",
    contaCredito: f.contaCredito ?? "",
    descricaoCredito: f.descricaoCredito ?? "",
    dtInicio: String(f.dtInicio ?? "").trim(),
    dtFim: String(f.dtFim ?? "").trim(),
  };
}

/**
 * Normaliza resposta GET conciliacao para estado da UI.
 */
export function aplicarRespostaConciliacoes(response, { formatarData = formatarDataExibicaoBr, formatarQuantia } = {}) {
  const conciliacoesRaw = response?.conciliacoes ?? [];
  const conciliacoes = conciliacoesRaw.map((item) =>
    normalizarConciliacaoItem(item, {
      dtTransacao: formatarData(item.dtTransacao),
      ...(typeof formatarQuantia === "function"
        ? { quantia_cellVal: formatarQuantia(Number(item.quantia)) }
        : {}),
    })
  );
  const pag = response?.paginacao ?? {};
  return {
    conciliacoes,
    capaSaldo: response?.capaSaldo ?? null,
    paginacao: {
      pagina: pag.pagina ?? 0,
      tamanhoPagina: pag.tamanhoPagina ?? 10,
      totalItens: pag.totalItens ?? 0,
      totalPaginas: pag.totalPaginas ?? 0,
    },
  };
}
